import request from '@/utils/request'
import qs from 'qs'
//========= 客户报检量统计
export const customerCountDevice = (postData) => {
  return request({
    url: '/check/customerCountDevice',
    method: 'post',
    data: postData
  })
}
//报检量导出下载
export const customerCountDeviceDownload = (postData) => {
  return request({
    url: '/check/customerCountDeviceDownload',
    method: 'post',
    headers: {
      'content-type': 'application/x-www-form-urlencoded;'
    },
    data: qs.stringify(postData),
    responseType: 'blob'
  })
}
